<div class="sidebar-wrapper school-sidebar">
  <div class="school-sidebar__brand">
    <div class="school-sidebar__brand-icon">
      <i class="material-icons">school</i>
    </div>
    <div class="school-sidebar__brand-text">
      <div class="school-sidebar__school-name">{{ user?.school_name || "School" }}</div>
      <div class="school-sidebar__academic-year">{{ user?.academic_label || "Academic Year" }}</div>
      <div class="school-sidebar__brand-user">{{ displayUserName }}</div>
    </div>
  </div>

  <div class="school-sidebar__divider"></div>

  <nav class="school-sidebar__nav">
    <ng-container *ngFor="let menuitem of menuItems">
      <a
        *ngIf="menuitem.type === 'link'"
        [routerLink]="menuitem.path"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: menuitem.path === '/dashboard' }"
        class="school-sidebar__link"
      >
        <i class="material-icons">{{ menuitem.icontype }}</i>
        <span>{{ menuitem.title }}</span>
      </a>

      <ng-container *ngIf="menuitem.type === 'sub'">
        <button
          type="button"
          class="school-sidebar__link school-sidebar__link--parent"
          [class.is-active]="isParentActive(menuitem)"
          [class.is-expanded]="isExpanded(menuitem)"
          (click)="toggleSubmenu(menuitem)"
        >
          <i class="material-icons">{{ menuitem.icontype }}</i>
          <span class="school-sidebar__link-label">{{ menuitem.title }}</span>
          <i class="material-icons school-sidebar__caret">expand_more</i>
        </button>

        <div class="school-sidebar__submenu" [class.is-open]="isExpanded(menuitem)">
          <a
            *ngFor="let childitem of menuitem.children"
            [routerLink]="[menuitem.path, childitem.path]"
            routerLinkActive="is-active"
            class="school-sidebar__sublink"
          >
            {{ childitem.title }}
          </a>
        </div>
      </ng-container>
    </ng-container>
  </nav>

  <div class="school-sidebar__footer">
    <div class="school-sidebar__divider"></div>

    <div *ngIf="isMobileMenu()" class="school-sidebar__mobile-actions">
      <button type="button" class="school-sidebar__action" (click)="changePass()">
        <i class="material-icons">lock</i>
        <span>Change Password</span>
      </button>
      <button type="button" class="school-sidebar__action school-sidebar__action--danger" (click)="logoutAction()">
        <i class="material-icons">power_settings_new</i>
        <span>Logout</span>
      </button>
    </div>

    <div class="school-sidebar__user">
      <div class="school-sidebar__avatar">{{ userInitials }}</div>
      <div class="school-sidebar__user-meta">
        <div class="school-sidebar__user-name">{{ displayUserName }}</div>
        <div class="school-sidebar__user-role">{{ userRole }}</div>
      </div>
    </div>
  </div>
</div>
